import { Head, Form, Link } from "@inertiajs/react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, FieldGroup, FieldError, FieldLabel, FieldSet } from "@/components/ui/field";
import H3 from "@/components/ui/h3";

export default function SignUp() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Head title="Sign Up" />
      <Form action="/sign_up" method="POST" className="w-full max-w-[380px]">
        {({ errors }) => (
          <FieldSet>
            <H3>Sign Up</H3>
            <FieldGroup>
              <Field data-invalid={!!errors.name}>
                <FieldLabel htmlFor="sign-up-name">Name</FieldLabel>
                <Input id="sign-up-name" name="name" placeholder="Jane Smith" aria-invalid={!!errors.name} required />
                {errors.name && (<FieldError>{errors.name}</FieldError>)}
              </Field>

              <Field data-invalid={!!errors.email}>
                <FieldLabel htmlFor="sign-up-email">Email</FieldLabel>
                <Input id="sign-up-email" name="email" placeholder="example@email.com" aria-invalid={!!errors.email} required />
                {errors.email && (<FieldError>{errors.email}</FieldError>)}
              </Field>

              <Field data-invalid={!!errors.password}>
                <FieldLabel htmlFor="password">Password</FieldLabel>
                <Input id="password" type="password" name="password" placeholder="••••••••" aria-invalid={!!errors.password} required />
                {errors.password && (<FieldError>{errors.password}</FieldError>)}
              </Field>

              <Field orientation="horizontal">
                <Button type="submit">Sign Up</Button>
              </Field>

              <p className="text-sm text-muted-foreground">
                Already have an account?{" "}
                <Link href="/sign_in" className="underline">Sign in</Link>
              </p>
            </FieldGroup>
          </FieldSet>
        )}
      </Form>
    </div>
  );
}
